import styled, { css } from 'styled-components'

export const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['16']};
    width: 47rem;
  `,
)

export const DetailsCard = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['12']};
    padding: ${theme.space['16']};
    background: ${theme.colors.white};
    border-radius: ${theme.border.radius['10']};
    border: ${theme.border.size['1']} solid ${theme.colors.gray500};
  `,
)

export const DetailRow = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${theme.space['8']};
  `,
)

export const Separator = styled.hr(({ theme }) => ({
  background: theme.colors.gray300,
  border: 'none',
  height: `${theme.border.size['1']}`,
  margin: 0,
}))

export const CarrierLogo = styled.img({
  maxHeight: '2rem',
  maxWidth: '9.3rem',
  objectFit: 'contain',
})
